module.exports = __webpack_public_path__ + "img/section-3.eea07940.png";